export const industrialVocabulary = [
  {
    word: "Scaffold",
    meaning: "비계, 건설용 발판",
    audioId: 1,
    imageUrl: "/images/vocabulary/industrial/indu1.png",
  },
  {
    word: "Warehouse",
    meaning: "창고",
    audioId: 2,
  },
  {
    word: "Pallet",
    meaning: "팔레트, 화물 운반대",
    audioId: 3,
    imageUrl: "/images/vocabulary/industrial/indu3.png",
  },
  {
    word: "Assembly line",
    meaning: "조립 라인",
    audioId: 4,
  },
  {
    word: "Loading dock",
    meaning: "화물 선적장",
    audioId: 5,
  },
  {
    word: "Forklift",
    meaning: "지게차",
    audioId: 6,
    imageUrl: "/images/vocabulary/industrial/indu6.png",
  },
  {
    word: "Cardboard Box",
    meaning: "골판지 상자",
    audioId: 7,
    imageUrl: "/images/vocabulary/industrial/indu7.png",
  },
  {
    word: "Load",
    meaning: "적재하다, 싣다",
    audioId: 8,
  },
  {
    word: "Operate",
    meaning: "작동하다, 운전하다",
    audioId: 9,
  },
  {
    word: "Packing Material",
    meaning: "포장 재료",
    audioId: 10,
  },
  {
    word: "Secure",
    meaning: "고정하다, 안전하게 하다",
    audioId: 11,
  },
  {
    word: "Container",
    meaning: "컨테이너",
    audioId: 12,
  },
  {
    word: "Cargo",
    meaning: "화물",
    audioId: 13,
    imageUrl: "/images/vocabulary/industrial/indu13.png",
  },
  {
    word: "Freight",
    meaning: "화물, 운송",
    audioId: 14,
  },
  {
    word: "Cargo Ship",
    meaning: "화물선",
    audioId: 15,
  },
  {
    word: "Dock",
    meaning: "부두, 선착장",
    audioId: 16,
  },
  {
    word: "Welding Torch",
    meaning: "용접 토치",
    audioId: 17,
  },
  {
    word: "Solar Panel",
    meaning: "태양광 패널",
    audioId: 18,
    imageUrl: "/images/vocabulary/industrial/indu18.png",
  },
  {
    word: "Adjust",
    meaning: "조정하다, 맞추다",
    audioId: 19,
  },
  {
    word: "Blueprint",
    meaning: "청사진, 설계도",
    audioId: 20,
    imageUrl: "/images/vocabulary/industrial/indu20.png",
  },
  {
    word: "Safety Vest",
    meaning: "안전 조끼",
    audioId: 21,
    imageUrl: "/images/vocabulary/industrial/indu21.png",
  },
  {
    word: "Clipboard",
    meaning: "클립보드, 서류철",
    audioId: 22,
  },
  {
    word: "Wheelbarrow",
    meaning: "손수레",
    audioId: 23,
    imageUrl: "/images/vocabulary/industrial/indu23.png",
  },
  {
    word: "Flooring",
    meaning: "바닥재, 마루",
    audioId: 24,
  },
  {
    word: "Parcel",
    meaning: "소포, 꾸러미",
    audioId: 25,
    imageUrl: "/images/vocabulary/industrial/indu25.png",
  },
  {
    word: "Crate",
    meaning: "나무 상자, 화물 상자",
    audioId: 26,
    imageUrl: "/images/vocabulary/industrial/indu26.png",
  },
  {
    word: "Shipping Label",
    meaning: "배송 라벨",
    audioId: 27,
  },
  {
    word: "Plastic",
    meaning: "비닐, 플라스틱",
    audioId: 28,
  },
  {
    word: "Unload",
    meaning: "하역하다, 짐을 내리다",
    audioId: 29,
  },
  {
    word: "Seal",
    meaning: "밀봉하다, 봉인하다",
    audioId: 30,
  },
  {
    word: "Assemble",
    meaning: "조립하다, 모으다",
    audioId: 31,
  },
  {
    word: "Ascend",
    meaning: "올라가다",
    audioId: 32,
  },
  {
    word: "Descend",
    meaning: "내려가다",
    audioId: 33,
  },
  {
    word: "Climb stairs",
    meaning: "계단을 올라가다",
    audioId: 34,
  },
  {
    word: "Go down stairs",
    meaning: "계단을 내려가다",
    audioId: 35,
  },
  {
    word: "Janitor",
    meaning: "관리인, 청소부",
    audioId: 36,
  },
  {
    word: "Transport",
    meaning: "운송하다, 수송하다",
    audioId: 37,
  },
  {
    word: "Empty",
    meaning: "비우다, 비어있는",
    audioId: 38,
  },
  {
    word: "Power drill",
    meaning: "전동 드릴",
    audioId: 39,
  },
  {
    word: "Mechanic",
    meaning: "정비공, 기계공",
    audioId: 40,
  },
  {
    word: "Hammer",
    meaning: "망치, 망치로 치다",
    audioId: 41,
  },
  {
    word: "Safety gear",
    meaning: "안전 장비",
    audioId: 42,
  },
  {
    word: "Shut",
    meaning: "닫다, 폐쇄하다",
    audioId: 43,
  },
  {
    word: "Stack",
    meaning: "쌓다, 더미",
    audioId: 44,
  },
  {
    word: "Carry",
    meaning: "운반하다, 나르다",
    audioId: 45,
  },
  {
    word: "Disassemble",
    meaning: "분해하다",
    audioId: 46,
  },
  {
    word: "Power tool",
    meaning: "전동 공구",
    audioId: 47,
  },
  {
    word: "Electronic cord",
    meaning: "전기 코드",
    audioId: 48,
  },
  {
    word: "Base of",
    meaning: "~의 기초, ~의 바닥",
    audioId: 49,
  },
  {
    word: "Prop against",
    meaning: "~에 기대어 놓다",
    audioId: 50,
  },
  {
    word: "A power cord",
    meaning: "전원 코드",
    audioId: 51,
  },
  {
    word: "Portion",
    meaning: "부분, 일부",
    audioId: 52,
  },
  {
    word: "Stepladder",
    meaning: "접이식 사다리",
    audioId: 53,
  },
  {
    word: "Work crew",
    meaning: "작업 인원, 작업팀",
    audioId: 54,
  },
  {
    word: "Clearing",
    meaning: "정리, 청소",
    audioId: 55,
  },
  {
    word: "Greenhouse",
    meaning: "온실",
    audioId: 56,
  },
  {
    word: "Trim",
    meaning: "다듬다, 손질하다",
    audioId: 57,
  },
  {
    word: "Dirt",
    meaning: "흙, 먼지",
    audioId: 58,
  },
];
